import Vue from 'vue';
import Router from 'vue-router';
import Onboarding from '@/components/Onboarding.vue';
import Overview from '@/components/Overview.vue';
import Settings from '@/components/Settings.vue';
import Transactions from '@/components/Transactions.vue';
import db from '@/db';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'overview',
      component: Overview,
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: Transactions,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: Onboarding,
      beforeEnter(to, from, next) {
        db.appData.get('user').then((user) => {
          if (user && user.onboardingComplete) next('/');
          else next();
        });
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  db.appData.get('user').then((user) => {
    if ((user && user.onboardingComplete) || to.name === 'onboarding') next();
    else next('/onboarding');
  });
});

export default router;
